
<div class="tooltip bg-gray-700 text-gray-200 shadow-lg rounded p-2" [ngStyle]="{top: position.top, left: position.left}" [innerHTML]="text">

</div>
